export default {
  methods: {
    /**
     *
     * @param {string} refName
     * @param {number} type:1-ref名称，适用于vue实例；2-class名称，适用于原生元素
     */
    handleOutside(refNames, type) {
      let refsArr = []
      if (typeof refNames == 'string') {
        refsArr.push(refNames)
      } else if (Array.isArray(refNames)) {
        refsArr = [...refNames]
      } else {
        return false;
      }

      switch (type) {
        case 1:
          for (let idx = 0; idx < refsArr.length; idx++) {
            const refName = refsArr[idx]
            const ref = this.$refs[refName] || null
            if (ref) {
              // 延迟执行，保证原有事件得到正常执行
              setTimeout(() => {
                ref.hide()
              }, 300)
            }
          }
          break
        case 2:
          for (let idx = 0; idx < refsArr.length; idx++) {
            const selector = refsArr[idx];
            const elms = document.querySelectorAll(selector) || []
            for (let index = 0; index < elms.length; index++) {
              const element = elms[index];
              let className = element.className
              element.className = className.replace('show', '')
            }
          }

          break

        default:
          break;
      }
    },
    //判断权限
    hasPermission(permissionStr, permission) {
      if (permissionStr === 'all') {
        return true
      }
      return permissionStr.split(',').includes(permission)
    },
    hasPermissionNot(permissionStr, permission) {
      if (permissionStr === 'all') {
        return false
      }
      return permissionStr.split(',').includes(permission)
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js